import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { isLight, isUpOrSmart } from "./selectors/userInfoSelectors";
import DashboardHeader from "./components/DashboardHeader";
import DashboardSinglePageEmptyState from "./components/EmptyStates/DashboardSinglePageEmptyState";
import DashboardSingleSection from "./DashboardSingleSection";
import DashboardTabsSection from "./DashboardTabsSection";
import { DashboardModuleWrapper } from "./style";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { Store } from "@reduxjs/toolkit";
import { ThemeProvider } from "emotion-theming";
import { theme } from "nectar-ui";
import reduxStoreHelper from "./utils/helpers/reduxStoreHelper";

const queryClient = new QueryClient();

type DashboardModuleType = {
  store: Store;
};

const DashboardModule: React.FC<DashboardModuleType> = ({ store }) => {
  useEffect(() => {
    reduxStoreHelper.setStore(store);
  }, []);

  const shouldRenderLightEmptyState = useSelector(isLight);
  const shouldRenderSingleTab = useSelector(isUpOrSmart);

  const DashboardModuleContent = () => {
    if (shouldRenderLightEmptyState) return <DashboardSinglePageEmptyState />;
    if (shouldRenderSingleTab) return <DashboardSingleSection />;
    return <DashboardTabsSection />;
  };

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme.standard}>
          <DashboardModuleWrapper>
            <DashboardHeader />
            <DashboardModuleContent />
          </DashboardModuleWrapper>
        </ThemeProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </Provider>
  );
};

export default DashboardModule;
